var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

const React = require('react');
const Icon = require('@infotech/uikit-icon').default;

function Svg(props) {
  const svgProps = Object.assign({}, props);
  const title = props.title;
  delete props.title;

  /* <svg {...svgProps} ><title>{title}<title>...</svg> */
  return React.createElement(
    'svg',
    _extends({ width: '24', height: '24', viewBox: '0 0 24 24', focusable: 'false' }, svgProps, { 'aria-labelledby': 'title' }),
    React.createElement(
      'title',
      { id: 'title' },
      title
    ),
    React.createElement('path', { d: 'M2.629 5.749l9-3.6a1 1 0 01.742 0l9 3.6a1 1 0 01.629.928v10.646a1 1 0 01-.629.928l-9 3.6a1 1 0 01-.742 0l-9-3.6A1 1 0 012 17.323V6.677a1 1 0 01.629-.928zM4 16.614l7 2.847V11.65L4 8.539v8.075zm9-4.964v7.811l7-2.847V8.539l-7 3.11zm-1-7.556L5.462 7l1.765.784 6.556-2.897L12 4.094zM9.712 8.89L12 9.906 18.538 7 16.25 5.983 9.712 8.89z', fillRule: 'evenodd', role: 'presentation' })
  );
}

module.exports = function resourceTypesMenu(props) {
  return React.createElement(Icon, _extends({ glyph: Svg }, props));
};